import { Checkbox } from '@mui/material';
import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';

export const StyledWrapper = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        align-items: ${theme.isRebranding('inherit', 'center')};
        min-width: ${theme.tggSpacing(rem(10), 78)};
        gap: ${theme.tggSpacing((rem(0), 2))};
        span {
            max-height: fit-content;
        }
    `}
`;

export const StyledCheckbox = styled(Checkbox)`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        align-items: ${theme.isRebranding('baseline', 'center')};
        justify-content: ${theme.isRebranding('inherit', 'center')};
        padding: ${theme.tggSpacing([0, 0], [0, 0])};
        background-color: ${theme.getRebrandingColor(
            theme.palette.grey[900],
            theme.palette.tgg.surface.action.selection.deactivated,
        )};
        border: ${theme.tggSpacing((rem(0), 0.25))} solid ${theme.getRebrandingColor(
            'inherit',
            theme.palette.tgg.border.selection.deactivated,
        )};
        
        border-radius: 50%;

        &.Mui-checked,
        &.Mui-checked:hover {
            background-color: ${theme.getRebrandingColor(
                theme.palette.secondary.main,
                theme.palette.tgg.surface.action.selection.activated,
            )};
        }
        
        &.Mui-focusVisible {
            outline: ${theme.tggSpacing((rem(0.1), 0.5))} solid 
            ${theme.getRebrandingColor(
                theme.palette.primary.main,
                theme.palette.tgg.border.focus.main,
            )};
            outline-offset: ${theme.tggSpacing((rem(0), 0.5))};
            border-radius: 50%;
        }

        &:hover {
            background-color: ${theme.getRebrandingColor(
                theme.palette.grey[900],
                theme.palette.tgg.surface.action.selection.deactivated,
            )};
            box-shadow: 0 0 0 ${theme.tggSpacing((rem(0), 2))} ${theme.getRebrandingColor(
                'inherit',
                theme.palette.tgg.surface.action.selection.hover,
            )};
        }

        &.Mui-checked:hover {
            box-shadow: 0 0 0 ${theme.tggSpacing((rem(0), 2))} ${theme.getRebrandingColor(
                'inherit',
                theme.palette.tgg.surface.action.selection.hover,
            )};
        }
        
        &:not(.Mui-checked):active {
            box-shadow: 0 0 0 ${theme.tggSpacing((rem(0), 2))} ${theme.getRebrandingColor(
                'inherit',
                theme.palette.tgg.surface.action.selection.pressed,
            )};
        }

        &.Mui-checked:active {
            box-shadow: 0 0 0 ${theme.tggSpacing((rem(0), 2))} ${theme.getRebrandingColor(
                'inherit',
                theme.palette.tgg.surface.action.selection.pressed,
            )};
        }

        &.Mui-disabled,
        &.Mui-checked.Mui-disabled:hover {
            background-color: ${theme.palette.tgg.surface.action.disabled};
            border-color: ${theme.palette.tgg.border.disabled};
            box-shadow: none;
            outline: none;
            cursor: not-allowed;
            pointer-events: none; 
        }

        &.Mui-disabled:hover,
        &.Mui-disabled:focus,
        &.Mui-disabled:active {
            box-shadow: none;
            outline: none;
        }
        
        &.Mui-checked.Mui-disabled {
            outline: none;
            border: none; 
        }
                
    }

        svg {
            padding: ${theme.tggSpacing(rem(0.2), 0)};
        }
    `}
`;

export const StyledLabel = styled('label')`
    ${({ theme }: { theme: Theme }) => `
        display: inline-block;
        padding: ${theme.tggSpacing([0, rem(1)], [0, 0])};
        font-weight: 500;
        cursor: pointer;
        user-select: none;
    `}
    ${({ theme }: { theme: Theme }) =>
        theme.isRebranding('inherit', theme.typography.bodyStandardRebrand)};
`;

export const StyledErrorMessage = styled('div')<{ $error: any }>`
    color: ${({ $error }) => $error.main};
`;
